import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { FeedbackService } from '../../services/feedback.service';

@Component({
  selector: 'app-feedback-modal',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './feedback-modal.component.html',
  styleUrls: ['./feedback-modal.component.scss']
})
export class FeedbackModalComponent {
  private readonly modalRef = inject(BsModalRef);
  private readonly feedbackService = inject(FeedbackService);

  feedbackType: 'bug' | 'feature' | 'general' | 'improvement' = 'general';
  message: string = '';
  isSubmitting: boolean = false;

  feedbackTypes = [
    { value: 'bug', label: 'Bug melden', icon: 'bi-bug-fill', color: '#dc3545' },
    { value: 'feature', label: 'Feature-Wunsch', icon: 'bi-lightbulb-fill', color: '#ffc107' },
    { value: 'improvement', label: 'Verbesserung', icon: 'bi-arrow-up-circle-fill', color: '#0dcaf0' },
    { value: 'general', label: 'Allgemeines Feedback', icon: 'bi-chat-heart-fill', color: '#198754' }
  ];

  selectType(type: 'bug' | 'feature' | 'general' | 'improvement') {
    this.feedbackType = type;
  }

  async submitFeedback() {
    if (!this.message.trim()) {
      return;
    }

    this.isSubmitting = true;

    const success = await this.feedbackService.submitFeedback({
      type: this.feedbackType,
      message: this.message.trim()
    });

    this.isSubmitting = false;

    if (success) {
      this.close();
    }
  }

  close() {
    this.modalRef.hide();
  }

  get selectedTypeInfo() {
    return this.feedbackTypes.find(t => t.value === this.feedbackType);
  }

  getPlaceholder(): string {
    switch (this.feedbackType) {
      case 'bug':
        return 'Beschreibe den Fehler, den du gefunden hast. Was ist passiert? Welche Schritte hast du unternommen?';
      case 'feature':
        return 'Welche neue Funktion würdest du dir wünschen? Wie würde sie dir helfen?';
      case 'improvement':
        return 'Was können wir besser machen? Welche bestehende Funktion sollten wir verbessern?';
      case 'general':
        return 'Teile uns deine Gedanken mit. Was gefällt dir? Was nicht?';
      default:
        return 'Deine Nachricht...';
    }
  }
}

